import React from "react";
import TextField from "@material-ui/core/TextField";

const ICInput = props => (
  <TextField inputProps={{
    min: props.min,
    max: props.max
  }}
  className={"ic-input " + props.customCssClass}
  {...props} />
);

export default ICInput;
